module.exports = __webpack_public_path__ + "static/media/App-store-badge.2928664f.svg";